import type { SxProps, Theme } from '@mui/material';

export const root: SxProps<Theme> = {
  bgcolor: 'grey.50',
  borderRadius: 1,
  px: { xs: 3, md: 10, lg: 20 },
  py: 6,
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
};

export const headerBlock: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 1.5,
  textAlign: 'center',
};

export const tabs: SxProps<Theme> = {
  alignSelf: 'center',
};

export const sections: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 6,
};

export const sectionGroup: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5,
};

export const sectionTitle: SxProps<Theme> = {
  pl: 2,
};

export const itemList: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};
